import { CheckBox } from "@mui/icons-material";
import {
	Box,
	Checkbox,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	styled,
	TextField,
	useMediaQuery,
} from "@mui/material";
import React, { Component, useEffect, useRef, useState } from "react";
import { amber, headingBlue, pureWhite, seaGreen } from "../assets/colors";

function CustomDropDown(props) {
	const isMobile = useMediaQuery("(max-width:600px)");

	const menuListRef = useRef(null)

	// const [selected, setSelected] = useState([])

	// useEffect(() => {
	// 	if( props?.CheckBox){
	// 		setSelected(props?.list)
	// 	}
	// }, [props.CheckBox])

	const arraysAreEqualUnordered = (a, b) => {	
    return (
      a.length === b.length &&
      a.slice().sort().every((val, index) => val === b.slice().sort()[index])
    );
  };

	return props.regular ? (
		<>
			<Select
				variant="outlined"
				disabled={props.disabled}
				value={props.value}
				style={{
					textAlign: "left",
					width: props.width ? props.width : "6rem",
					color: props.placeHolder === props.value ? "#B0B0B0" : "black",
					height: props.height ? props.height : "2rem",
					padding: "0.1rem",
					paddingLeft: "0rem",
					boxShadow: "0 0.2rem 0.4rem 0 #D3D3D3",
					fontSize: isMobile ? "0.8rem" : "0.9rem",
				}}
				sx={{ fontSize: "0.9rem" }}
				MenuProps={{
					PaperProps: {
						style: {
							maxHeight: "184px",
							fontSize: "0.9rem",
							width: props.width && typeof props.width === 'string' && props.width.includes('%') ? undefined : (props.width ? props.width : "6rem"),
							"&::-webkit-scrollbar": {
								display: "none",
							},
							scrollbarWidth: "none",
						},
					},
				}}
				onChange={(e) => {
					props.isCount
						? props.setFunc(e.target.value, props.count):
						props.extraParamvalue ? 
						props.setFunc(e.target.value, true)
						: props.setFunc(e.target.value);
				}}
				displayEmpty
				renderValue={() => props.value}
			>
				{props.placeHolder && (
					<MenuItem value={props.value} disabled>
						{props.placeHolder}
					</MenuItem>
				)}

				{props.isValueRequired
					? props?.list?.map((option) => (
							<MenuItem key={option.name} value={option}>
								{option.name}
							</MenuItem>
					  ))
					: props.list.map((option) => (
							<MenuItem
								key={option.name}
								value={option.name}
								disabled={
									(props?.isDeletingLeader &&
										option.contactNumber === props.leaderContact) ||
									false
								}
							>
								{option.name}
							</MenuItem>
					  ))}
			</Select>
		</>
	) : 
	 props.isCheckBox ? (
	 	<>
			<Box style={{display: 'flex', alignItems: 'center'}}>
				<InputLabel style={{padding: '0.2rem 0.5rem'}}>{props.label}</InputLabel>
				<Select
					variant="outlined"
					disabled={props.disabled}
					multiple
					value={props.value}
					style={{
						textAlign: "left",
						width: props.width ? props.width : "6rem",
						color: props.placeHolder === props.value ? "#B0B0B0" : "black",
						height: props.height ? props.height : "2rem",
						padding: "0.1rem",
						paddingLeft: "0rem",
						boxShadow: "0 0.2rem 0.4rem 0 #D3D3D3",
						fontSize: isMobile ? "0.8rem" : "0.9rem",
					}}
					sx={{ fontSize: "0.9rem" }}
					MenuProps={{
						PaperProps: {
							ref: (node) => {
								menuListRef.current = node
							},
							style: {
								maxHeight: "184px",
								fontSize: "0.9rem",
								width: props.width && typeof props.width === 'string' && props.width.includes('%') ? undefined : (props.width ? props.width : "6rem"),
								"&::-webkit-scrollbar": {
									display: "none",
								},
								scrollbarWidth: "none",
							},
							sx: {
								// "& .MuiMenuItem-root.Mui-selected": {
								// 	backgroundColor: seaGreen,
								// 	color: headingBlue
								// }
							}
						}
					}}
					// onChange={(e) => {
					// 	props.setFunc(e?.target?.value)
					// }}
					onOpen={() => {
						setTimeout(() => {
							if(menuListRef.current){
								menuListRef.current.scrollTop = 0
							}
						}, 50)
					}}
					onChange={(e) => {
						if (e.target.value.includes("all")) {
							arraysAreEqualUnordered(props.value, props?.list?.map(opt => opt.name)) ? 
							props.setFunc([]) : props.setFunc(props?.list?.map(opt => opt.name)); 
						} else {
							props.setFunc(e.target.value);
						}
					}}
					renderValue={(selected) => 
						(	arraysAreEqualUnordered(selected, props?.list?.map(opt => opt.name))
						?
							'All' :
							// selected?.map((s) => s).join(', ')
							selected.length > 1 ? `${[...selected].sort()[0]} +${selected.length - 1}` : selected
						)
					}

				>
					<Box style={{display: 'flex', justifyContent: 'center'}}>
						{/* <TextField 
							variant="outlined"
							style={{ padding: '0rem'}}
							InputProps={{
								style: {
									height: "2rem"
								}
							}}
							></TextField>	 */}
					</Box>
					
					<MenuItem value="all">
						<Checkbox
							checked={arraysAreEqualUnordered(props.value, props?.list?.map(opt => opt.name))}
							style={{padding: '0rem 0.3rem 0rem 0rem'}}
						></Checkbox>
						All
					</MenuItem>
					{props?.list?.map((option) => (
						<MenuItem key={option.name}
							value={option.name}
						> 
						<Checkbox
							checked={props.value.indexOf(option.name) > -1}
							style={{padding: '0rem 0.3rem 0rem 0rem'}}
						></Checkbox>
						{option.name}
						{/* <CheckBox></CheckBox> */}
						</MenuItem>
					))}

				</Select>
			</Box>

	 
	 	</>
	) 
	:
	(
		<>
			<Select
				fullWidth={props.width ? false : true}
				disabled={props.disabled}
				variant="outlined"
				value={props.value}
				style={{
					fontSize: "0.9rem",
					textAlign: "left",
					color: props.placeHolder === props.value ? "#B0B0B0" : "black",
					height: props.height ? props.height : "2rem",
					padding: "0.2rem",
					paddingLeft: "0rem",
					boxShadow: "0 0.2rem 0.4rem 0 #D3D3D3",
					width: props.width ? props.width : undefined,
				}}
				sx={{ fontSize: "0.8rem" }}
				MenuProps={{
					PaperProps: {
						style: {
							maxHeight: "184px",
							fontSize: "0.9rem",
							width: props.width && typeof props.width === 'string' && props.width.includes('%') ? undefined : (props.width ? props.width : "6rem"),
							"&::-webkit-scrollbar": {
								display: "none",
							},
							scrollbarWidth: "none",
						},
					},
				}}
				onChange={(e) =>
					props.isCount
						? props.setFunc(e.target.value, props.count)
						: props.setFunc(e.target.value)
				}
				displayEmpty
				renderValue={() => props.value}
			>
				{/* {props.placeHolder && (
					<MenuItem value={props.value ? props.value : "Filter On"} disabled>
						{props.placeHolder}
					</MenuItem>
				)} */}

				{props.placeHolder && (
					<MenuItem value={props.placeHolder} disabled>
						{props.placeHolder}
					</MenuItem>
				)}

				{props.isValueRequired
					? props?.list?.map((option) => (
							<MenuItem key={option.name} value={option}>
								{option.name}
							</MenuItem>
					  ))
					: props?.list?.map((option) => (
							<MenuItem
								key={option.name ? option.name : option}
								value={option.name ? option.name : option}
							>
								{option.name ? option.name : option}
							</MenuItem>
					  ))}
			</Select>
		</>
	);
}

export default CustomDropDown;
